import { componentTypeSchema, type ComponentType } from "@shared/schema";

const componentTypeValues = componentTypeSchema.options;

export const isComponentType = (value: unknown): value is ComponentType => {
  return typeof value === "string" && componentTypeValues.includes(value as ComponentType);
};

export const ensureComponentType = (
  value: unknown,
  fallback: ComponentType = "other"
): ComponentType => {
  return isComponentType(value) ? value : fallback;
};

export const componentTypes = componentTypeValues;

